export default "/assets/images/mila-valentine.ab8bcc30f359b539.webp";